
import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import AlarmSetting from '../components/monitor/AlarmSetting';

const App = ({ intl, dispatch, loading, monitor }) => {
  return (
    <div className="container-left">
      <AlarmSetting
        intl={intl}
        dispatch={dispatch}
        loading={loading}
        monitor={monitor}
      />
    </div>
  );
};

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(App)
);



// WEBPACK FOOTER //
// ./src/routes/PanelAlarm.js